var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Portfolio as PortfolioModel } from '@/models/Portfolio';
import ErrorHandler from '@/support/ErrorHandler';
import _ from 'lodash';
import i18n from '@/i18n';
let ProgressLabel = class ProgressLabel extends Vue {
    constructor() {
        super(...arguments);
        this.portfolioClone = null;
        this.labels = [];
        this.isEditingLabels = false;
        this.isUpdatingLabels = false;
    }
    mounted() {
        this.initialize();
    }
    initialize() {
        this.portfolioClone = _.cloneDeep(this.portfolio);
        this.labels = this.portfolioClone.labels;
    }
    addLabel() {
        this.isEditingLabels = true;
        this.labels.push({
            name: this.$t('progress.label.new').toString(),
        });
    }
    updateLabels() {
        const payload = {
            labels: this.labels.map((label) => label.name),
        };
        new PortfolioModel()
            .updateRelation(this.portfolio.id, 'labels', '', payload)
            .then(() => {
            this.isEditingLabels = false;
            this.$emit('portfolioUpdated');
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    removeLabel(name) {
        if (!this.labels) {
            return;
        }
        this.labels = this.labels.filter((label) => {
            return label.name !== name;
        });
    }
    resetLabels() {
        this.labels = _.cloneDeep(this.portfolio).labels;
        this.isEditingLabels = false;
    }
    get user() {
        return this.$store.state.Auth;
    }
    get dialogOptions() {
        return {
            title: this.$t('progress.dialog.title').toString(),
            text: this.$t('progress.dialog.subtitle', { item: this.$tc('progress.label.title', 2) }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        this.updateLabels();
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.isUpdatingLabels = false;
                    },
                },
            },
        };
    }
};
__decorate([
    Prop({ default: {} }),
    __metadata("design:type", typeof (_a = typeof PortfolioModel !== "undefined" && PortfolioModel) === "function" ? _a : Object)
], ProgressLabel.prototype, "portfolio", void 0);
__decorate([
    Prop({ default: i18n.tc('progress.label.header') }),
    __metadata("design:type", String)
], ProgressLabel.prototype, "title", void 0);
ProgressLabel = __decorate([
    Component({
        components: {},
    })
], ProgressLabel);
export default ProgressLabel;
